var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowPrevIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56333 10.7761L0.170422 5.87336C-0.0568073 5.66698 -0.0568073 5.33356 0.170422 5.12664L5.56333 0.223935C5.89135 -0.0746448 6.42505 -0.0746448 6.75366 0.223935C7.08169 0.522514 7.08169 1.0071 6.75366 1.30568L2.14032 5.50027L6.75366 9.69378C7.08169 9.9929 7.08169 10.4775 6.75366 10.7761C6.42505 11.0746 5.89135 11.0746 5.56333 10.7761Z",
    fill: "#4D4D4D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowPrevIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowPrevIcon.cd924df6.svg";
export { ForwardRef as ReactComponent };